import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Play, Clock, Zap, Headphones, BookOpen, MessageCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

const typeIcons = {
  vocabulary: BookOpen,
  conversation: MessageCircle,
  listening: Headphones,
};

const typeColors = {
  vocabulary: 'text-primary bg-primary/10',
  conversation: 'text-accent bg-accent/10',
  listening: 'text-success bg-success/10',
};

const LessonCard = ({ lesson, trackId, className }) => {
  const navigate = useNavigate();
  const { id, title, titlePt, duration, xp, completed, current, type } = lesson;

  const TypeIcon = typeIcons[type] || BookOpen;

  const handleClick = () => {
    navigate(`/lesson/${trackId}/${id}`);
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'card-lesson w-full text-left flex items-center gap-4',
        current && 'border-primary/50 bg-primary/5',
        className
      )}
    >
      {/* Status Icon */}
      <div className={cn(
        'w-12 h-12 rounded-xl flex items-center justify-center shrink-0',
        completed ? 'bg-success/10' : current ? 'bg-primary/10' : 'bg-muted'
      )}>
        {completed ? (
          <Check className="w-5 h-5 text-success" />
        ) : current ? (
          <Play className="w-5 h-5 text-primary" />
        ) : (
          <TypeIcon className={cn('w-5 h-5', typeColors[type]?.split(' ')[0] || 'text-muted-foreground')} />
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <h4 className="font-medium text-sm truncate">{title}</h4>
          {current && (
            <span className="shrink-0 px-2 py-0.5 text-[10px] font-medium bg-primary text-primary-foreground rounded-full">
              ATUAL
            </span>
          )}
        </div>
        <p className="text-xs text-muted-foreground truncate">{titlePt}</p>
        
        {/* Meta info */}
        <div className="flex items-center gap-3 mt-2">
          <span className="flex items-center gap-1 text-xs text-muted-foreground">
            <Clock className="w-3 h-3" />
            {duration} min
          </span>
          <span className="flex items-center gap-1 text-xs text-muted-foreground">
            <Zap className="w-3 h-3" />
            {xp} XP
          </span>
          <span className={cn(
            'flex items-center gap-1 text-xs px-1.5 py-0.5 rounded',
            typeColors[type] || 'text-muted-foreground bg-muted'
          )}>
            <TypeIcon className="w-3 h-3" />
            <span className="capitalize">{type}</span>
          </span>
        </div>
      </div>
    </button>
  );
};

export default LessonCard;
